module.exports = __webpack_public_path__ + "static/media/weningsih-bio.0c8c4189.pdf";